export default {
  ApiCommon: require('./api-common').default,
  ApiOss: require('./api-oss').default,
  ApiUser: require('./api-user').default,
  ApiRole: require('./api-role').default,
  ApiCategory: require('./api-category').default,
  ApiBatch: require('./api-batch').default,
  ApiSubject: require('./api-subject').default,
  ApiSpecialty: require('./api-specialty').default,
  ApiAgent: require('./api-agent').default,
  ApiFeeAudit: require('./api-fee-audit').default,
  ApiTimeAudit: require('./api-time-audit').default,
  ApiGrade: require('./api-grade').default,
  ApiMenu: require('./api-menu').default,
  ApiExamOnline: require('./api-exam-online').default,
  ApiExamResult: require('./api-exam-result').default,
  ApiFaceCertify: require('./api-face-certify').default,
  ApiOrderOnline: require('./api-order-online').default,
  ApiVideo: require('./api-video').default,
  ApiArticle: require('./api-article').default,
  ApiBanner: require('./api-banner').default,
  ApiWhiteList: require('./api-white-list').default,
  GradeCommon: require('./grade-common').default,
  GradeExam: require('./grade-exam').default,
  GradeRemark: require('./grade-remark').default,
  GradeRoom: require('./grade-room').default,
  GradeSetting: require('./grade-setting').default,
  GradeUser: require('./grade-user').default,
}
